// Pill / radio options for the Kindergarten Final Observations form.

export const yearOptions = [
  { value: 'Year 1', label: 'Year 1 (JK)' },
  { value: 'Year 2', label: 'Year 2 (SK)' },
]

export const frenchOptions = [
  { value: '',          label: 'None' },
  { value: 'Immersion', label: 'Immersion' },
  { value: 'Core',      label: 'Core' },
  { value: 'Extended',  label: 'Extended' },
]

export const placementOptions = [
  { value: '',                    label: 'Not set' },
  { value: 'Kindergarten Year 2', label: 'Kindergarten Year 2' },
  { value: 'Grade 1',             label: 'Grade 1' },
]

export const ersCompletedOptions = [
  { value: '',    label: 'Not set' },
  { value: 'yes', label: 'Yes' },
  { value: 'no',  label: 'No' },
  { value: 'na',  label: 'N/A' },
]

export const ersBenchmarkOptions = [
  { value: '',    label: 'Not set' },
  { value: 'yes', label: 'Yes' },
  { value: 'no',  label: 'No' },
]
